<template>
  <div>
    <Header v-if="!$route.meta.clearLayout" />
    <section class="main-content">
      <router-view />
    </section>
    <Footer v-if="!$route.meta.clearLayout" />
  </div>
</template>

<script>
import config from "@/config";
import TextAreaDialog from "@/components/internal/TextAreaDialog.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { EventsOn } from "@/../wailsjs/runtime/runtime";
// import { bus } from "@/bus.js";

export default {
  components: {
    TextAreaDialog,
    Header,
    Footer,
  },
  name: "App",
  created() {
    try {
      EventsOn("send:status", function (sendStatus) {
        console.log("console status:", sendStatus);
      });
    } catch (e) { }
  },
  mounted() {
    let that = this;
    // setInterval(() => {
    //   this.$socket.emit("emit_method", "kekeke");
    // }, 5000);
    if (config.desktop_mode) {
    } else {
      this.sockets.subscribe("notifications", (data) => {
        try {
          // this.msg = data.message;
          let msg = JSON.parse(data.message);
          let obj = { dangerouslyUseHTMLString: true };
          if (msg.title) {
            obj["title"] = msg.title;
          }
          if (msg.message) {
            obj["message"] = msg.message;
          }
          if (msg.duration) {
            obj["duration"] = parseInt(msg.duration);
          } else {
            obj["duration"] = 0;
          }
          that.$notify.info(obj);
        } catch (e) {
          console.log(e);
        }
      });
    }
  },
};
</script>

<style lang="less">
//@import "assets/styles/index.less";</style>



// WEBPACK FOOTER //
// src/App.vue